export const SHOWANIMATIONDRAWING= 'drawing';
export const SHOWANIMATIONNODRAWING = 'noDrawing';
